import {makeStyles, withStyles} from "@material-ui/core/styles";
import {StepConnector, Typography} from "@material-ui/core";
import clsx from "clsx";
import React, {useState} from "react";
import Step from "@material-ui/core/Step";
import StepLabel from "@material-ui/core/StepLabel";
import Stepper from "@material-ui/core/Stepper";
import i18n from "../../../i18nextInitiator";

/**
 * Translate
 * @type {TFunction}
 */
const t = i18n.getFixedT('fa','general');
/**
 * JSS
 * @type {(props?: any) => ClassNameMap<"stepper"|"label">}
 */
const useStyles = makeStyles((theme) => ({
    stepper: {
        width: "100%"
    },
    label: {
        marginTop: ".5rem !important"
    }
}));

/**
 * This Component Represent the Steps in the tracking page.
 * @param props
 * @returns {JSX.Element}
 * @constructor
 */
const NobaarStepper = props => {
    const classes = useStyles();
    /*** Steps titles.*/
    const [steps, setSteps] = useState([t('steps.0'),t('steps.1'),t('steps.2'),t('steps.3')]);
    const getStep = ()=>{
        switch (props.status) {
            case 2:
                return '1';
            case 4:
                return '2';
            case 5:
                return '3';
            case 6:
                return '4';

            default:
                return '';
        }
    }

    return <Stepper className={classes.stepper} activeStep={getStep()} connector={<DashedConnector/>} alternativeLabel>
        {steps.map((label) => (
            <Step key={label}>
                <StepLabel classes={{label: classes.label}} StepIconComponent={NobaarStepIcon}>{label}</StepLabel>
            </Step>
        ))}
    </Stepper>

}
export default NobaarStepper;
/**
 * styles for the connector between each step icon.
 * @type {React.ComponentType<Omit<JSX.LibraryManagedAttributes<(props: StepConnectorProps) => JSX.Element, React.ComponentProps<(props: StepConnectorProps) => JSX.Element>>, keyof ({theme: Theme} & {classes: ClassNameMap<ClassKeyOfStyles<"line">>}) | {classes: ClassNameMap<ClassKeyOfStyles<"line">>}> & StyledComponentProps<"line">>}
 */
const DashedConnector = withStyles({
    line: {
        border:"dashed 1px #d7d9ea"
    },
})(StepConnector)
/**
 * Styles for the icons.
 * @type {(props?: any) => ClassNameMap<"root"|"active"|"completed">}
 */
const useStepIconStyles = makeStyles(theme=>({
    root: {
        backgroundColor: theme.palette.primary.light,
        zIndex: 1,
        color: '#fff',
        width: "2rem",
        height: "2rem",
        display: 'flex',
        borderRadius: '50%',
        justifyContent: 'center',
        alignItems: 'center',
    },
    active: {
        backgroundColor: theme.palette.primary.main,
        border:`solid 2px ${theme.palette.primary.light}`
    },
    completed: {
        backgroundColor: theme.palette.primary.main,
        border:`solid 2px ${theme.palette.primary.light}`
    },
}));
/**
 * This Component represents each step icon.
 * @param props
 * @returns {JSX.Element}
 * @constructor
 */
const NobaarStepIcon = props => {
    const classes = useStepIconStyles();
    const { active, completed } = props;

    return<div className={clsx(classes.root, {[classes.active]: active, [classes.completed]: completed})}>
        <Typography color={!active && !completed ? "primary" : '#fff'}>
            {props.icon}
        </Typography>
    </div>
};
